import {
  AuthApi,
  Configuration,
  ManagementApi,
  MemberApi,
  Middleware,
  NotificationApi,
  OnboardingApi,
  ResponseContext,
  UserApi,
} from '@quick/client';
import { env } from 'configs/EnvironmentConfig';
import store from 'redux/store';
import { signOut } from 'redux/actions';
import { auth } from 'auth/firebaseAuth';

const basePath = env.REACT_APP_API_ENDPOINT_URL;

const authorizationMiddleware: Middleware = {
  pre: async (context) => {
    const token = await auth.currentUser?.getIdToken();

    context.init.headers = {
      ...context.init.headers,
      'Firebase-auth': 'true',
      Authorization: 'Bearer ' + token,
    };

    return context;
  },
  post: async (context: ResponseContext) => {
    const response = context.response;
    if (response.status === 401) {
      await auth.signOut();
      store.dispatch(signOut());
    }
    return context.response;
  },
};

export const memberApi = new MemberApi(
  new Configuration({
    basePath,
    middleware: [authorizationMiddleware],
  })
);

export const notificationApi = new NotificationApi(
  new Configuration({
    basePath,
    middleware: [authorizationMiddleware],
  })
);

export const managementApi = new ManagementApi(
  new Configuration({
    basePath,
    middleware: [authorizationMiddleware],
  })
);

export const authApi = new AuthApi(
  new Configuration({
    basePath,
  })
);

export const onboardingApi = new OnboardingApi(
  new Configuration({
    basePath,
    middleware: [authorizationMiddleware],
  })
);

export const userApi = new UserApi(
  new Configuration({
    basePath,
    middleware: [authorizationMiddleware],
  })
);
